import { SetState } from 'zustand';
import { ValueState } from '@ui5/webcomponents-react';
import { CommonCorporateContentQueryState } from 'stores/interfaces/CommonQueryState';

export const commonCorporateContentQueryInitialStateFields = {
  xtmProjectName: undefined,
  fileName: ''
};

export const commonCorporateContentQueryInitialStateValueStates = {
  fileNameValueState: ValueState.None
};

export const commonCorporateContentQueryInitialState = {
  ...commonCorporateContentQueryInitialStateFields,
  ...commonCorporateContentQueryInitialStateValueStates,
  fetching: false
};

export const createCommonCorporateContentQuerySlice = <T extends CommonCorporateContentQueryState>(
  set: SetState<T>
) => ({
  ...commonCorporateContentQueryInitialState,
  setXtmProjectName: (value?: string) => set(() => ({ xtmProjectName: value })),
  setFileName: (value: string) => set(() => ({ fileName: value })),
  setFileNameValueState: (value: ValueState) =>
    set(() => ({
      fileNameValueState: value
    })),
  setFetching: (value: boolean) => set(() => ({ fetching: value })),
  resetData: () =>
    set({
      xtmProjectName: '',
      fileName: '',
      fileNameValueState: ValueState.None
    })
});
